import { IAdvisor } from "./Advisor";
import { ICompany } from "./Company";
import { IProject } from "./Project";
import { IProfile } from "./Profile";
import { ITouchpoint } from "./Touchpoint";
import { IMediaResponse } from "./MediaResponse";

export enum ViewpointStatus {
    NOT_STARTED = "not_started",
    IN_PROGRESS = "in_progress",
    COMPLETED = "completed",
    APPROVED = "approved",
    REJECTED = "rejected",
    DISQUALIFIED = "disqualified",
    DELETED = "deleted"
}

export interface IViewpoint {
    id: number;
    alchemer_id: number;
    uuid: string;
    name: string;
    email: string;
    title: string;
    company_name: string;
    location: string;
    category: string;
    image: string;
    linkedin: string;
    demand: string;
    interest_demo: boolean;
    interest_beta: boolean;
    interest_advisor: boolean;
    interest_employment: boolean;
    interest_followup: boolean;
    interest_investor: boolean;
    investment_amount_low: number;
    investment_amount_high: number;
    has_video: boolean;
    has_audio: boolean;
    hidden_from_guest: boolean;
    included_in_analysis: boolean;
    created_at: string;
    updated_at: string;
    highlight_quote?: string;
    published_at?: string;
    advisor?: IAdvisor;
    role?: string;
    max_spend?: number;
    company?: ICompany;
    project: IProject;
    is_approved: boolean;
    is_published: boolean;
    is_reviewed: boolean;
    is_stale: boolean;
    prospect_hidden: boolean;
    profile?: IProfile;
    score?: number;
    touchpoint?: ITouchpoint;
    response_json?: any; // @TODO: Replace with json structure
    media_responses?: IMediaResponse[];
    status?: ViewpointStatus;
    alchemer_survey_url?: string;
    alchemer_session_id?: string;
    is_featured?: boolean;
    is_mobile?: boolean;
}
